module.exports = __webpack_public_path__ + "static/img/bg-best-costume-design.51a3786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-best-costume-design.jpg
// module id = 311
// module chunks = 0